import React from 'react';
import {StyleSheet, View} from 'react-native';
import {Colors} from '../../theme';
import {Text} from './Text';

// 新規登録停止のお知らせ。未ログインの画面の一番上に出す
// TODO(MLM-11626): メンテナンスが終わったら、この変更（MLM-11626）を revert して帯を消す

const MESSAGE = `現在、システムメンテナンスのため、トリマビジネスアカウントの新規登録を一時停止しております。
大変ご迷惑をおかけして申し訳ございませんが、メンテナンス終了まで今しばらくお待ちいただきますよう、お願いいたします。`;

export const SignUpSuspendedNotice: React.FC = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.text}>{MESSAGE}</Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: '#FFF3E0',
    borderBottomWidth: 2,
    borderBottomColor: Colors.accent,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  text: {
    color: Colors.delete,
    fontWeight: 'bold',
    textAlign: 'center',
  },
});
